import { User, ArrowDownToLine, Wallet, Repeat, Send, CheckCircle2 } from "lucide-react";

const stages = [
  { label: "Customer", icon: User },
  { label: "Collect", icon: ArrowDownToLine },
  { label: "Swiftwire", icon: null, highlight: true },
  { label: "Hold", icon: Wallet },
  { label: "Convert", icon: Repeat },
  { label: "Send", icon: Send },
  { label: "Settle", icon: CheckCircle2 },
];

const Connector = ({ vertical = false, delay = "0s" }) =>
  vertical ? (
    <div className="relative mx-auto h-10 w-px bg-white/25" aria-hidden="true">
      <span className="sw-travel-dot-y on-dark" style={{ animationDelay: delay }} />
    </div>
  ) : (
    <div className="relative h-px min-w-6 flex-1 bg-white/25 md:mt-3 md:-translate-y-[18px]" aria-hidden="true">
      <span className="sw-travel-dot on-dark" style={{ animationDelay: delay, top: "-3.5px" }} />
    </div>
  );

const Node = ({ stage }) => {
  if (stage.highlight) {
    return (
      <div className="flex flex-col items-center gap-2.5">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-white/40 bg-white p-2 shadow-lg shadow-black/20">
          <img src="/logo-mark.png" alt="Swiftwire" className="h-full w-full object-contain" />
        </div>
        <p className="text-sm font-bold text-white">{stage.label}</p>
      </div>
    );
  }
  const Icon = stage.icon;
  return (
    <div className="flex flex-col items-center gap-2.5">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/15 bg-white/10 text-blue-100 shadow-sm backdrop-blur">
        <Icon size={20} strokeWidth={1.5} />
      </div>
      <p className="text-sm font-semibold text-blue-100">{stage.label}</p>
    </div>
  );
};

const MoneyFlowDiagram = () => (
  <div data-testid="money-flow-diagram" className="rounded-3xl border border-[#1E3A6E] bg-gradient-to-br from-[#14294f] via-[#1E3A6E] to-[#16305e] p-8 shadow-xl shadow-[#1E3A6E]/20 md:p-12">
    {/* Desktop: horizontal */}
    <div className="hidden items-center md:flex">
      {stages.map((s, i) => (
        <div key={s.label} className="flex flex-1 items-center last:flex-none">
          <Node stage={s} />
          {i < stages.length - 1 && <Connector delay={`${i * 0.45}s`} />}
        </div>
      ))}
    </div>
    {/* Mobile: vertical */}
    <div className="flex flex-col md:hidden">
      {stages.map((s, i) => (
        <div key={s.label}>
          <div className="flex justify-center">
            <Node stage={s} />
          </div>
          {i < stages.length - 1 && <Connector vertical delay={`${i * 0.35}s`} />}
        </div>
      ))}
    </div>
  </div>
);

export default MoneyFlowDiagram;
